// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9.52521 0.625977L21.8996 13.0003L12.0001 22.8998L2.10059 13.0003L10.5859 4.51506L8.11099 2.04019L9.52521 0.625977ZM5.92921 12.0002H18.071L12.0001 5.92928L5.92921 12.0002ZM20.7498 17.3891L22.0642 19.0493C22.645 19.7829 22.645 20.8968 22.0642 21.6304C21.7495 22.0279 21.2803 22.2872 20.7498 22.2872C20.2193 22.2872 19.7501 22.0279 19.4355 21.6304C18.8546 20.8968 18.8546 19.7829 19.4355 19.0493L20.7498 17.3891Z"}}]};

const FillColorFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'fill-color-filled',
    ref,
    icon: element,
  },
));

FillColorFilledIcon.displayName = 'FillColorFilledIcon';

export default FillColorFilledIcon;
